// extracted by mini-css-extract-plugin
module.exports = {"heading":"_28e339bd","icon":"_e3b3c5a4"};